import { Link } from 'react-router-dom';
import { useCookieConsent } from '@/hooks/useCookieConsent';

export function CookieBanner() {
  const { showBanner, accept, reject } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-semantic-border bg-semantic-surface p-4 shadow-lg md:bottom-6 md:left-6 md:right-auto md:max-w-md md:rounded-xl md:border"
      role="dialog"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-desc"
    >
      <h2 id="cookie-banner-title" className="font-heading text-lg font-semibold">
        Preferencias de cookies
      </h2>
      <p id="cookie-banner-desc" className="mt-2 text-sm text-semantic-text-secondary">
        Utilizamos cookies esenciales para el funcionamiento del sitio. Con tu consentimiento, también usamos
        analítica para mejorar la experiencia.{' '}
        <Link to="/cookies" className="text-semantic-accent underline">
          Más información
        </Link>
      </p>
      <div className="mt-4 flex flex-wrap gap-3">
        <button type="button" onClick={accept} className="btn-primary text-sm">
          Aceptar
        </button>
        <button type="button" onClick={reject} className="btn-secondary text-sm">
          Rechazar
        </button>
      </div>
    </div>
  );
}
